import React, { useEffect, useState } from 'react';
import Confetti from 'react-confetti';
import { soundService } from '../services/SoundService';
import { hapticService } from '../services/HapticService';
import './CelebrationEffect.css';

/**
 * CelebrationEffect Component
 * Shows confetti and celebration animations
 */
function CelebrationEffect({
  active = false,
  duration = 3000,
  type = 'confetti',
  message = '🎉 Great Job!',
  onComplete
}) {
  const [showEffect, setShowEffect] = useState(false);
  const [dimensions, setDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });

  useEffect(() => {
    const handleResize = () => {
      setDimensions({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (active) {
      // Play celebration sound and haptic when effect becomes active
      soundService.playAchievement();
      hapticService.notification();
      
      setShowEffect(true);
      const timer = setTimeout(() => {
        setShowEffect(false);
        if (onComplete) onComplete();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [active, duration, onComplete]);

  if (!showEffect) return null;

  return (
    <div className="celebration-overlay">
      {type === 'confetti' && (
        <Confetti
          width={dimensions.width}
          height={dimensions.height}
          recycle={false}
          numberOfPieces={200}
          gravity={0.3}
          colors={['#FFD700', '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4', '#FFEAA7']}
        />
      )}

      {message && (
        <div className="celebration-message">
          <span className="celebration-text">{message}</span>
        </div>
      )}

      {type === 'stars' && (
        <div className="stars-container">
          {[...Array(20)].map((_, i) => (
            <div 
              key={i} 
              className="floating-star"
              style={{
                left: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 0.5}s`
              }}
            >
              ⭐
            </div>
          ))}
        </div>
      )}

      {type === 'fireworks' && (
        <div className="fireworks-container">
          {[...Array(5)].map((_, i) => (
            <div 
              key={i}
              className="firework"
              style={{
                left: `${20 + i * 15}%`,
                animationDelay: `${i * 0.2}s`
              }}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default CelebrationEffect;